<template>
  <Container>
    <div style="height:50px;padding:10px;">
      <Input search style="width:200px;" v-model="filter.search" placeholder="搜索用户" />
    </div>
    <div style="height:calc(100% - 50px);">
      <BaseTable :columns="columns" :data="filteredUsers" border />
    </div>
    <BaseLoadingModal v-model="loading" />
  </Container>
</template>

<script>
import Container from '@/components/app/container.vue';
export default {
  components: {
    Container,
  },
  data() {
    return {
      items: [],
      filter: {
        search: '',
      },
      loading: false,
    };
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.getData();
    });
  },
  methods: {
    getData() {
      this.Loading = true;
      this.$api.get('/admin/users').then((res)=>{
        this.items = res.data.data;
        this.loading = false;
      });
    },
  },
  computed: {
    filteredUsers() {
      return this.items.filter((v)=>{
        if (this.filter.search && v.name.includes(this.filter.search) == false) {
          return false;
        }
        return true;
      });
    },
    columns() {
      return [{
        type: 'index',
        width: 80,
      }, {
        title: '用户名',
        key: 'name',
        width: 120,
      }, {
        title: '电话',
        key: 'phone',
        width: 220,
      }, {
        title: '微信',
        key: 'wechat',
        width: 120,
        render: (h, {row})=>{
          const key = row.wechat;
          return h('div', {style: `padding:2px 5px;margin:0 10px;border-radius:5px;background:var(${key?'--success':'--border'});color:var(${key?'--hover-text':'--text2'})`}, key?'已绑定':'未绑定');
        },
      }, {
        title: '钉钉',
        key: 'ding_id',
        width: 120,
        render: (h, {row})=>{
          const key = row.ding_id;
          return h('div', {style: `padding:2px 5px;margin:0 10px;border-radius:5px;background:var(${key?'--success':'--border'});color:var(${key?'--hover-text':'--text2'})`}, key?'已绑定':'未绑定');
        },
      }, {
        title: 'ZZL平台',
        key: 'zzl_id',
        width: 120,
        render: (h, {row})=>{
          const key = row.zzl_id;
          return h('div', {style: `padding:2px 5px;margin:0 10px;border-radius:5px;background:var(${key?'--success':'--border'});color:var(${key?'--hover-text':'--text2'})`}, key?'已绑定':'未绑定');
        },
      }, {
        title: '密码',
        key: 'password',
        width: 120,
        render: (h, {row})=>{
          const key = row.password;
          return h('div', {style: `padding:2px 5px;margin:0 10px;border-radius:5px;background:var(${key?'--success':'--border'});color:var(${key?'--hover-text':'--text2'})`}, key?'已设置':'未设置');
        },
      }, {
        title: '最后登录',
        key: 'last_logined_at',
        width: 120,
        type: 'time',
      }, {
        title: '登录状态',
        width: 120,
        type: 'state',
        key: 'status',
        option: {
          colormap: {
            'active': 'var(--primary)',
            'warn-1': 'var(--warning)',
          },
        },
      }, {
        title: '账号状态',
        width: 120,
        type: 'state',
        key: 'state',
        option: {
          states: ['正常', '禁用'],
          colors: ['var(--primary)', 'var(--error)'],
        },
      }, {
        title: '操作',
        key: 'tool',
        render: (h, {row})=>{
          const buttons = [{
            name: '重置密码',
            url: '/admin/users/reset-pwd',
          }, {
            name: '禁用',
            url: '/admin/users/disable',
            vif: (row)=>!row.state?true:false,
          }, {
            name: '启用',
            url: '/admin/users/enable',
            vif: (row)=>!row.state?false:true,
          },{
            name: '登录',
            action:(row)=>{
              this.$store.dispatch('session/loginByID', {id: row.id}).then(res=>{
                this.RouteTo('/core/dashboard');
              }).catch(err=>{
                this.Error(err);
              });
            }
          }];
          return h('div', {class: 'flex-wrap flex-center split5'}, buttons.filter((v)=>{
            return v.vif?v.vif(row):true;
          }).map((v)=>{
            return h('Button', {props: {
              size: 'small',
            },
            on: {
              click: ()=>{
                if(v.action){ 
                  v.action(row);
                }else{
                  this.$api.post(v.url, {
                  id: row.id,
                }).then((res)=>{
                  this.Success({title: '操作成功'});
                  this.getData();
                });
                }
                
              },
            }}, v.name);
          }));
        },

      }];
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
